module.exports = __webpack_public_path__ + "static/img/top.95fa94b7.png";